import { createRouter, createWebHistory } from 'vue-router';
import { projectName } from '@/config/config';
import { trackRouter } from 'vue-gtag-next';

/**
 * meta description.
 * @param {string} title - document title。
 * @param {boolean} keepAlive - 頁面是否需緩存，預設為 false。
 * @param {boolean} isNavShow - 是否顯示 navbar，預設為 true。
 * @param {boolean} navIconType - icon 類型。
 * @param {string} navBgColor - navbar 背景顏色。
 * @param {boolean} auth - 頁面是否需要權限，預設為 false
*/
const routes = [
  {
    path: '/',
    redirect: '/page_redirect'
  },
  {
    path: '/page_redirect/:scheme/:source?',
    name: 'pageRedirect',
    component: () => import('../views/pageRedirect.vue'),
    alias: '/external/page_redirect/:scheme/:source?',
    meta: { title: '全支付跳轉', key: 1 }
  },
  {
    path: '/sw_page_redirect/:scheme/:source?',
    name: 'swPageRedirect',
    component: () => import('../views/swPageRedirect.vue'),
    meta: { title: '三星全支付跳轉', key: 2 }
  },
  {
    path: '/test_page',
    name: 'testPage',
    component: () => import('../views/testPage.vue'),
    meta: { title: '測試跳轉', key: 3 }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    let position = { left: 0, top: 0 };

    if (savedPosition && to.meta.keepAlive) {
      position = savedPosition;
    }

    return position;
  }
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  next();
});

trackRouter(router, {
  template (to) {
    return {
      page_view: `${projectName}${to.path}`
    };
  }
});

export default router;
